module.exports = __webpack_public_path__ + "static/media/BIO.325c7220.apng";